import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { MenuItem } from "../shared/models/user.model";

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  private apiURL = 'https://api.diazar.app/menu';

  constructor(private http: HttpClient) {}

  getMenuItems(): Observable<MenuItem[]> {
    return of([
      {
        title: 'Inicio',
        icon: 'home',
        to: '/',
      },
      {
        title: 'Gestión de Obras',
        icon: 'diazar:user-hard-hatOutlined',
        children: [
          {
            title: 'Requisiciones',
            to: '/requisiciones/all',
          },
          {
            title: 'Estimaciones',
            to: '/estimaciones',
          },
        ],
      },
    ]);

    //return this.http.get(this.apiURL);
  }
}
